<template>
  <div>
    <FiltroAnexos
      :value="showFiltro"
      @filtrar-anexos="filtrarAnexos"
      @limpar-filtro="cleanFiltro()"
      @close="showFiltro = false"
    />

    <table-cadu
      :class="$vuetify.breakpoint.xs ? 'mandatos-mobile' : 'mandatos'"
      ref="tableAnexoAdmin"
      v-model="selected"
      texto=""
      custom
      nameTab="anexosAdmin"
      :limiteChecks="15"
      :loading="isLoading"
      :showCheck="true"
      :showDownload="true"
      :botaoSelecionarLixeira="false"
      :botaoBaixarTodos="true"
      :rows="rows"
      :rowsHeader="rowsHeader"
      :items="['05', '10', '15']"
      :elementsPerPageProp="elementsPerPage"
      :pagina="pagina"
      :qtPaginas="qtPaginas"
      :qtResultados="qtResultados"
      :ordemProp="ordem"
      :disabledButtons="[false, false, true, true, false]"
      @clickButton="clickButtons"
      @change-element="(element) => changeSelect(element)"
      @change-page="(page) => changePage(page)"
      @ordena="(ordem) => ordenaTable(ordem)"
      @download="downloadGrid()"
      @filtro-click="showFiltro = true"
    />

    <SucessoModal :genericMessage="messageSuccess" :showSucess="showSuccess" @close="showSuccess = false" />

    <ExcluirModal
      :text="'Tem certeza que deseja excluir esse anexo permanentemente?'"
      :showDelete="showDelete"
      @close="showDelete = false"
      @confirmDelete="apagarAnexo"
    />

    <ErrorModal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

import Anexo from '@/services/Anexos/Anexo'
import FiltroAnexos from './FiltroAnexos'
import ErrorModal from '@/components/Shared/ErrorModal/ErrorModal'

export default {
  components: {
    FiltroAnexos,
    ErrorModal
  },
  props: {
    role: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      perfilAcesso: this.role,

      // OBJETO
      anexos: {},

      rowsHeader: [
        { text: 'Nome do Arquivo', icon: 'repeat' },
        { text: 'Aba Relacionada', icon: 'repeat' },
        { text: 'Data Upload', icon: 'repeat' },
        { text: 'Unimed', icon: 'repeat' },
        { text: 'Nome do usuário', icon: 'repeat' }
      ],
      rows: [],
      elementsPerPage: '10',
      pagina: 1,
      qtPaginas: 1,
      qtResultados: 0,
      ordem: 'asc',
      campoOrdenado: '',
      isLoading: true,
      selected: [],

      anexoId: 0,

      // FILTRO
      showFiltro: false,
      abaRelacionada: '',
      dataFim: '',
      dataInicio: '',
      tipoDocumentoId: '',
      codigoUnimed: '',

      messageSuccess: '',
      showSuccess: false,
      showDelete: false,

      error: false,
      errObj: {},
      loadingOverlay: false
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
    await this.getData(`tamanhoPagina=${this.elementsPerPage}`)
  },
  methods: {
    async getData(args) {
      this.showSucess = false
      this.isLoading = true
      await this.getAnexos(args)
      this.isLoading = false
    },
    async getAnexos(args) {
      const anexo = new Anexo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await anexo
        .getAllAnexo(args)
        .then(({ data }) => {
          this.rows = data.conteudo
          this.pagina = data.pagina
          this.qtPaginas = data.qtPaginas
          this.qtResultados = data.qtResultados
        })
        .catch((err) => {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
    },
    async paginate() {
      this.isLoading = true
      await this.getAnexos(this.args)
      this.isLoading = false
    },

    async apagarAnexo() {
      this.loadingOverlay = true
      this.showDelete = false

      const anexo = new Anexo(this.tokenBearer, this.$appConfig.config.API, this.anexoId)

      await anexo
        .deleteAnexo(this.versaoUnimedId)
        .then(() => {
          this.messageSuccess = 'Anexo apagado com sucesso!'
          this.showSuccess = true
          this.paginate()
        })
        .catch((err) => {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
        .finally(() => (this.loadingOverlay = false))
    },

    changeSelect(element) {
      this.elementsPerPage = element
      this.pagina = 1
      this.paginate()
    },
    changePage(page) {
      this.pagina = page.currentPage
      this.paginate()
    },
    ordenaTable(ordem) {
      this.setCampoOrdenado(ordem.index)
      this.ordem = ordem.ordem
      this.paginate()
    },
    setCampoOrdenado(index) {
      switch (index) {
        case 0:
          this.campoOrdenado = 'tipoDocumento.nome,anoDocumento'
          break
        case 1:
          this.campoOrdenado = 'abaRelacionada'
          break
        case 2:
          this.campoOrdenado = 'dataUpload'
          break
        case 3:
          this.campoOrdenado = 'codigoUnimed'
          break
        default:
          this.campoOrdenado = ''
          break
      }
    },
    clickButtons(item) {
      const selected = this.rows.filter((el) => item.selected.includes(el.id));
      switch (item.type) {
        case 'recibo':
          this.downloadArquivo(item.index)
          break

        case 'downAll':
          this.downloadMultiples(selected)
          break

        case 'delete':
          this.anexoId = this.rows[item.index].id
          this.versaoUnimedId = this.rows[item.index].versaoUnimedId
          this.showDelete = true
          break

        default:
          break
      }
    },
    async downloadGrid() {
      const anexo = new Anexo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      this.loadingOverlay = true

      await anexo
        .exportarGrid(this.args)
        .then((response) => this.download(response))
        .catch((err) => {
          const response = this.parseBlobToJSON(err.response.data)

          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = response.message
        })
        .finally(() => (this.loadingOverlay = false))
    },

    async downloadArquivo(index) {
      const image = `${this.$appConfig.config.API}/api/arquivos/${this.rows[index].arquivo.container}/${this.rows[index].arquivo.uuid}`
      const anexo = new Anexo(this.tokenBearer, this.$appConfig.config.API, this.rows[index].unimed.codigo)

      this.loadingOverlay = true

      await anexo
        .exportarAnexo(image)
        .then((response) => this.download(response))
        .catch((err) => {
          const response = this.parseBlobToJSON(err.response.data)

          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = response.message
        })
        .finally(() => (this.loadingOverlay = false))
    },
    async downloadMultiples(list) {
      this.loadingOverlay = true

      const anexo = new Anexo(this.tokenBearer, this.$appConfig.config.API)
      const uuids = list.map((it) => it.arquivo.uuid)

      await anexo
        .exportarMultiplosAnexos(uuids)
        .then((response) => this.download(response))
        .catch((err) => {
          const response = this.parseBlobToJSON(err.response.data)

          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = response.message
        })
        .finally(() => (this.loadingOverlay = false))
    },

    download(response) {
      let content = response.headers['content-disposition']

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', content.substring(content.indexOf('"'), content.lastIndexOf('"')))
      document.body.appendChild(link)

      link.click()
    },
    parseBlobToJSON(blob) {
      var xmlHttp

      const url = window.URL.createObjectURL(new Blob([blob]))
      xmlHttp = new XMLHttpRequest()
      xmlHttp.open('GET', url, false)
      xmlHttp.send()
      URL.revokeObjectURL(url)

      return JSON.parse(xmlHttp.responseText)
    },

    cleanFiltro() {
      this.$refs.tableAnexoAdmin.unselectedAllChecks()

      this.getData('')
    },
    filtrarAnexos(filtro) {
      this.$refs.tableAnexoAdmin.unselectedAllChecks()

      this.codigoUnimed = filtro.unimed !== '' ? filtro.unimed : ''
      this.abaRelacionada = filtro.abaRelacionada.codigo
      this.tipoDocumentoId = filtro.tipoDocumento !== '' ? filtro.tipoDocumento.id : ''
      this.dataInicio = filtro.dataInicial
      this.dataFim = filtro.dataFinal
      this.pagina = 1
      this.getData(this.args)
    }
  },
  watch: {
    anexos() {
      this.rows = this.anexos.conteudo
      this.pagina = this.anexos.pagina
      this.qtPaginas = this.anexos.qtPaginas
      this.qtResultados = this.anexos.qtResultados
    }
  },
  computed: {
    args() {
      return `direcaoOrdenacao=${this.ordem}&ordenacao=${this.campoOrdenado}&pagina=${this.pagina}&tamanhoPagina=${this.elementsPerPage}&abaRelacionada=${this.abaRelacionada}&dataFim=${this.dataFim}&dataInicio=${this.dataInicio}&tipoDocumentoId=${this.tipoDocumentoId}&codigoUnimed=${this.codigoUnimed}`
    }
  }
}
</script>

<style lang="sass">
.mandatos-mobile > .table-cadu
    padding: 20px 10px !important
    border: none
    border-radius: 0px
    width: 100% !important

.mandatos > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important

.mandatos > .table-cadu > .table > table
    width: 100% !important

.mandatos-mobile > .table-cadu > .table > table
    width: 100% !important

.mandatos > .table-cadu > .table
  max-height: 225px
  overflow: auto
  table
    width: 100%

.mandatos > .table-cadu > .table
  tbody
        tr
            td
                &:last-child
                    width: 200px
</style>
